<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="cont"><span class="underline">  Contents  </span></h2>
<p class="tocb"><a href="#/xhtml/introduction#int">Introduction</a></p>
<p class="toc-chap"><a href="#/xhtml/chapter_01#ch1">1    The Newtonian Revolution</a></p>
<p class="toc-chap"><span href="#/xhtml/chapter_02#ch2" title="Link target outside of Sample">2    The Western Paradigm Decisively Shifts</span></p>
<p class="toc-chap"><span href="#/xhtml/chapter_03#ch3" title="Link target outside of Sample">3    Popular Audiences and Public Experiments</span></p>
<p class="toc-chap"><span href="#/xhtml/chapter_04#ch4" title="Link target outside of Sample">4    Practicality and the Radicalism of Experiment</span></p>
<p class="toc-chap"><span href="#/xhtml/chapter_05#ch5" title="Link target outside of Sample">5    Putting Science to Work: European Strategies</span></p>
<p class="toc"><span href="#/xhtml/epilogue#epi" title="Link target outside of Sample">Epilogue</span></p>
<p class="toct"><span href="#/xhtml/notes#not" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/xhtml/acknowledgments#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><span href="#/xhtml/index#ind" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?f5942e44